<div *ngIf="shouldIndicatorBeRendered" class="current-time-indicator" [style.width.%]="width"></div>
